module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#environment",
      toString: function () {
        return this.url;
      }
    }